import {
  type PaymentStatuses,
  type PriceBreakdown,
  type PriceBreakdownType,
  MWToSellerKey,
  SellerToMWKey,
} from '../../containers/app/payments/Payments.types';

export const getPriceBreakdownAmountByType = (
  priceBreakdown: PriceBreakdown[],
  type: PriceBreakdownType,
  fallback: Nilable<PriceBreakdown['amount']> = 0,
) : typeof fallback => {
  const el = priceBreakdown.find((item: PriceBreakdown) => item.type === type);
  return el ? el.amount : fallback;
};

export const getPriceBreakdownFormattedAmountByType = (
  priceBreakdown: PriceBreakdown[],
  type: PriceBreakdownType,
) : string => {
  const el = priceBreakdown.find((item: PriceBreakdown) => item.type === type);
  return el?.amountFormatted || '0.00';
};

export const getHasNegativeEquity = (priceBreakdown: PriceBreakdown[]) : boolean => priceBreakdown.some((item) => item.type === 'seller_amount' && item.amount < 0);

export const getMWVsSellerDataOld = (responseData: PaymentStatuses[]) => {
  const data = responseData
    .sort((a: PaymentStatuses, b: PaymentStatuses) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .find((item: PaymentStatuses) => item.type === MWToSellerKey || item.type === SellerToMWKey) || null;

  return {
    paymentStatus: data?.status || null,
    reference: data?.reference || null,
  };
};

export const getMWVsSellerData = (responseData: PaymentStatuses[]) => responseData
  .sort((a: PaymentStatuses, b: PaymentStatuses) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
  .find((item: PaymentStatuses) => item.type === MWToSellerKey || item.type === SellerToMWKey) || null;
